import React, { useEffect, useRef, useState } from 'react'
import styles from './FlyersSection.module.css'
import { db } from '../../firebase'
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore'
import { 
  FLYERS_SECTION_CONTENT, 
  FLYERS_SETTINGS 
} from '../../Constants'

const FlyersSection = () => {
  const [flyers, setFlyers] = useState([])
  const [active, setActive] = useState(0)
  const intervalRef = useRef(null)

  // 🔥 Fetch Flyers from Firestore
  useEffect(() => {
    const q = query(
      collection(db, FLYERS_SETTINGS.collectionName),
      orderBy(
        FLYERS_SETTINGS.orderField,
        FLYERS_SETTINGS.orderDirection
      )
    )

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const flyerData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
      setFlyers(flyerData)
    })

    return () => unsubscribe()
  }, [])

  // 🕒 Auto slide
  const startAuto = () => {
    stopAuto()
    intervalRef.current = setInterval(() => {
      setActive(prev =>
        prev === flyers.length - 1 ? 0 : prev + 1
      )
    }, FLYERS_SETTINGS.autoSlideInterval)
  }

  const stopAuto = () => {
    if (intervalRef.current) clearInterval(intervalRef.current)
  }

  const prev = () => {
    stopAuto()
    setActive(prev =>
      prev === 0 ? flyers.length - 1 : prev - 1
    )
    startAuto()
  }

  const next = () => {
    stopAuto()
    setActive(prev =>
      prev === flyers.length - 1 ? 0 : prev + 1
    )
    startAuto()
  }

  useEffect(() => {
    if (flyers.length > 0) startAuto()
    return stopAuto
  }, [flyers])

  if (flyers.length === 0) {
    return (
      <div className={styles.loading}>
        {FLYERS_SECTION_CONTENT.loadingText}
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.topLine}></div>

      <div className={styles.header}>
        <h2>{FLYERS_SECTION_CONTENT.heading}</h2>
        <p>{FLYERS_SECTION_CONTENT.description}</p>
      </div>

      <div className={styles.carousel}>
        <button className={styles.arrowLeft} onClick={prev}>
          &#8592;
        </button>

        <div
          className={styles.track}
          onMouseEnter={stopAuto}
          onMouseLeave={startAuto}
        >
          {flyers.map((item, i) => {
            let position = styles.hidden

            if (i === active) position = styles.active
            else if (i === (active - 1 + flyers.length) % flyers.length)
              position = styles.prev
            else if (i === (active + 1) % flyers.length)
              position = styles.next
            else if (i === (active - 2 + flyers.length) % flyers.length)
              position = styles.farPrev
            else if (i === (active + 2) % flyers.length)
              position = styles.farNext

            return (
              <div key={item.id} className={`${styles.slide} ${position}`}>
                <img src={item.imageUrl} loading="lazy" alt="Flyer" />

                {i === active && (
                  <div className={styles.bottomInfo}>
                    <span>{item.day}</span>
                    <span>──</span>
                    <strong>{item.date}</strong>
                  </div>
                )}
              </div>
            )
          })}
        </div>

        <button className={styles.arrowRight} onClick={next}>
          &#8594;
        </button>
      </div>
    </div>
  )
}

export default FlyersSection